"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const undef = void 0;
const DEFAULT_ARIA_LABELS = {
  close: 'Close modal'
};
/**
 * Platform independent base class for platform specific implementations to inherit from.
 *
 * @displayName Base
 * @extends React.Component
 * @class Base
 * @public
 */

class Base extends _react.Component {
  constructor(props = {}) {
    super(...arguments);
    this.state = {
      open: props.open
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.onBackgroundClick = this.onBackgroundClick.bind(this);

    this._warn();
  }

  _warn() {
    if (process.env.NODE_ENV === 'production') return;

    if (this.props.header && !this.props['aria-labelledby']) {
      console.warn('Warning: If you manually provide a header you must set aria-labelledby manually otherwise a11y will not work');
    }

    if (this.props.header && !this.props['aria-describedby']) {
      console.warn('Warning: If you manually provide a body you must set aria-describedby manually otherwise a11y will not work');
    }
  }
  /**
   * Remove all added information.
   *
   * @private
   */


  componentWillUnmount() {
    this.close();
  }
  /**
   * On change of `open` prop, update internal state
   *
   * @param {Object} prevProps - Object of Previous Props
   * @private
   */


  componentDidUpdate(prevProps) {
    if (typeof this.props.open !== 'undefined' && prevProps.open !== this.props.open) {
      const action = this.props.open ? this.open : this.close;
      action();
    }
  }
  /**
   * Open the modal dialog again.
   *
   * @public
   */


  open() {
    this.setState({
      open: true
    }, () => {
      if (this.componentDidMount) {
        this.componentDidMount();
      }
    });
  }
  /**
   * Close the dialog
   *
   * @public
   */


  close() {
    const {
      state,
      props
    } = this; //
    // Return early if the dialog is not open. This prevents the onClose handler
    // from being called twice if the modal is closed normally.
    //

    if (state.open === false) {
      return;
    }

    this.setState({
      open: false
    }); //
    // Optionally call the close callback that has been provided to the modal
    // dialog.
    //

    if (typeof props.onClose === 'function') {
      props.onClose(this);
    }
  }
  /**
   * Closes this instance unless disableAutoClose it truthy
   *
   * @public
   */


  onBackgroundClick() {
    if (!this.props.disableAutoClose) {
      this.close();
    }
  }

  baseRender(Header, Nav, Body, Footer) {
    const {
      props
    } = this;

    const header = props.header || /*#__PURE__*/_react.default.createElement(Header, {
      key: "header",
      onClick: props.closeButton && this.close,
      disableAutoClose: props.disableAutoClose,
      ariaLabels: props.ariaLabels,
      id: `${props.id}-header`
    }, props.title);

    const nav = props.nav ? /*#__PURE__*/_react.default.createElement(Nav, {
      key: "nav"
    }, props.nav) : undef;

    const body = props.body || /*#__PURE__*/_react.default.createElement(Body, {
      id: `${props.id}-body`,
      key: "body"
    }, props.children);

    const footer = props.footer ? /*#__PURE__*/_react.default.createElement(Footer, {
      key: "footer"
    }, props.footer) : undef;
    return [header, nav, body, footer].filter(Boolean);
  }

}
/**
 * Enforce properties.
 *
 * @type {Object}
 * @api private
 */


exports.default = Base;
Base.propTypes = {
  /** Enables or disables animations */
  'animate': _propTypes.default.bool,

  /** Include or exclude the backdrop*/
  'backdrop': _propTypes.default.bool,

  /** Include or exclude a close button in the default header */
  'closeButton': _propTypes.default.bool,

  /** Will disable automatic closing via the ESC key or clicking on the backdrop */
  'disableAutoClose': _propTypes.default.bool,

  /** The location where the backdrop needs to be added */
  'target': _propTypes.default.object,

  /** The root document to attach the tooltip, defaults to document.documentElement. Used to support Shadow DOM */
  'root': _propTypes.default.node,

  /** Callback to be fired when the modal is closed */
  'onClose': _propTypes.default.func,

  /** Dictates if the modal is open */
  'open': _propTypes.default.bool,

  /** Classes to be applied to the modal */
  'className': _propTypes.default.string,

  /** A custom header to be rendered */
  'header': _propTypes.default.node,

  /** Required ID for a11y */
  'id': _propTypes.default.string.isRequired,

  /** Text to be displayed in the modal's header */
  'title': _propTypes.default.string,

  /** Content of the modal footer */
  'footer': _propTypes.default.node,

  /** The content of the modal */
  'body': _propTypes.default.node,

  /** Custom navigation to be rendered */
  'nav': _propTypes.default.node,

  /** Custom modal style to be rendered */
  'style': _propTypes.default.object,

  /** Child elements */
  'children': _propTypes.default.node,

  /** Screenreader labels */
  'ariaLabels': _propTypes.default.shape({
    /** Screen reader label for close button */
    close: _propTypes.default.string
  }),

  /** Required for manual modal header */
  'aria-labelledby': _propTypes.default.string,

  /** Required for manual modal body */
  'aria-describedby': _propTypes.default.string
};
Base.defaultProps = {
  animate: true,
  backdrop: true,
  closeButton: true,
  disableAutoClose: false,
  open: true,
  style: {},
  ariaLabels: DEFAULT_ARIA_LABELS
};